import { render } from "./changeStatus.vue?vue&type=template&id=e32f261a"
import script from "./changeStatus.vue?vue&type=script&lang=js"
export * from "./changeStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__